export class Recommandation {
    libelle: string;
    date_echeance: string;
    date_recommandation: string;
    structures_associees: string;
    mission_id: any;
    niveau_execution: any;
    type_mission: any;
    service_id: any
    reference: any

    private errorMessage: string;
  
    constructor() {
      this.errorMessage = "";
    }
  
    // Get error message
    getErrorMessage(): string {
      return this.errorMessage;
    }
  
    // Check for save
    canSave(): boolean {
  
      if (this.mission_id === undefined || this.mission_id === null) {
        this.errorMessage = "Veuillez sélectionner la mission";
        return false;
      }

      if (this.libelle === undefined || this.libelle === null || this.libelle.trim() === "") {
        this.errorMessage = "Veuillez saisir le libellé";
        return false;
      }
      
  
      if (this.date_recommandation === undefined || this.date_recommandation === null) {
        this.errorMessage = "Veuillez saisir la date de la recommandation";
        return false;
      }

     if (this.date_echeance === undefined || this.date_echeance === null) {
        this.errorMessage = "Veuillez saisir la date d'écheance de la recommandation";
        return false;
      }

      if (this.date_echeance <  this.date_recommandation) {
        this.errorMessage = "La date d'écheance de la recommandation doit être ultérieure à la date de la recommandation";
        return false;
      }

      if (this.service_id === undefined || this.service_id === null) {
        this.errorMessage = "Veuillez sélectionner la structure responsable";
        return false;
      }

       if (this.niveau_execution === undefined || this.niveau_execution === null ) {
        this.errorMessage = "Veuillez renseigner le niveau d'exécution de la mission";
        return false;
      }

      // Vérification de la plage de valeurs (0 à 100)
      if (this.niveau_execution < 0 || this.niveau_execution > 100) {
        this.errorMessage = "Veuillez saisir un pourcentage valide (entre 0 et 100).";
        return false;
      }
  
      this.errorMessage = "";
      return true;
    }//end canSave
}

export class SuivieRecommandation {
  user_reference: string;
  libelle: string;
  date_suivi: string;
  date_mo: string; 
  niveau_execution: number; 
  difficultes: string;
  solutions: string;
  reste_a_faire: string;
  observations: string;
  recommandation_id: string;
}
